import { gql } from "@apollo/client";

export const UPDATE_STUDENT_ANSWER_RECORD = gql`
  mutation UpdateStudentAnswerRecord($inputs: UpdateStudentAnswerRecordInputs!) {
    updateStudentAnswerRecord(inputs: $inputs) {
      status
      success
      message
      studentAnswerRecord {
        id
        userId
        correctAnswers
        incorrectAnswers
        totalAttempts
        lastUpdated
      }
    }
  }
`;
